(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sd-countdown]').forEach(function (root) {
      if (root.getAttribute('data-is-live') === 'true') { return; }
      var target = new Date(root.getAttribute('data-drop-time')).getTime();
      if (isNaN(target)) { return; }
      var elDays = root.querySelector('[data-sd-days]');
      var elHours = root.querySelector('[data-sd-hours]');
      var elMins = root.querySelector('[data-sd-mins]');
      var elSecs = root.querySelector('[data-sd-secs]');
      var timer = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (timer) { clearInterval(timer); }
          window.location.reload();
          return;
        }
        var s = Math.floor(diff / 1000);
        if (elDays) elDays.textContent = pad(Math.floor(s / 86400));
        if (elHours) elHours.textContent = pad(Math.floor((s % 86400) / 3600));
        if (elMins) elMins.textContent = pad(Math.floor((s % 3600) / 60));
        if (elSecs) elSecs.textContent = pad(s % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purple-world-drop-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSections = () => {
      document.querySelectorAll('[data-purple-world-drop-section]:not([data-purple-world-drop-ready])').forEach((root) => {
        root.dataset.purpleWorldDropReady = 'true';
        document.documentElement.classList.add('rm-purple-world-drop-page');

        const forms = root.querySelectorAll('[data-purple-world-drop-form]');

        const setHeaderHeight = () => {
          const pageOffset = Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY));
          root.style.setProperty('--purple-world-drop-header-height', `${pageOffset}px`);
        };

        setHeaderHeight();
        window.addEventListener('resize', setHeaderHeight, { passive: true });

        if (!forms.length) return;

        forms.forEach((form) => {
          const status = form.parentElement?.querySelector('[data-purple-world-drop-status]');
          const success = form.parentElement?.querySelector('[data-purple-world-drop-success]');
          const button = form.querySelector('button');
          const input = form.querySelector('input[type="email"]');

          if (!button || !input || !status || !success) return;

          const defaultStatus = status.textContent.trim();
        input.addEventListener('invalid', () => {
          input.setAttribute('aria-invalid', 'true');
          status.textContent = input.validationMessage;
          status.classList.add('purple-world-drop__status--error');
        });
        input.addEventListener('input', () => {
          input.removeAttribute('aria-invalid');
          status.textContent = defaultStatus;
          status.classList.remove('purple-world-drop__status--error');
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (button.disabled || !form.reportValidity()) return;
          form.setAttribute('aria-busy', 'true');
          input.readOnly = true;

          const originalLabel = button.textContent;
          button.textContent = root.dataset.language === 'en' ? 'Joining…' : (root.dataset.language === 'it' ? 'Invio…' : 'Inscription…');
          button.disabled = true;
          status.classList.remove('purple-world-drop__status--error');

          const shopify = window.Shopify || {};
          const params = new URLSearchParams(window.location.search || '');
          const language = root.dataset.language || 'fr';
          const source = root.dataset.source || 'purple-world-drop-2026-signup';
          const listId = root.dataset.listId;
          const market = shopify.routes?.root || '/';
          const country = shopify.country || '';
          const placement = form.dataset.formPlacement || 'hero';
          const properties = {
            Source: `Purple World Drop 2026 Landing Page - ${language.toUpperCase()}`,
            Drop: 'Purple World Drop 2026',
            RM_Channel: params.get('utm_medium') || 'organic',
            RM_Source: source,
            RM_Drop: 'purple_world_drop_2026',
            RM_Campaign: 'Purple World Drop 2026',
            Language: language,
            RM_Language: language,
            RM_Country: country,
            RM_Market_Root: market,
            Signup_Type: 'drop_notification',
            Form_Placement: placement,
            UTM_Source: params.get('utm_source') || 'instagram',
            UTM_Medium: params.get('utm_medium') || 'organic',
            UTM_Campaign: params.get('utm_campaign') || 'purple_world_drop_2026',
            UTM_Content: params.get('utm_content') || '',
            UTM_Term: params.get('utm_term') || '',
            Landing_Page: window.location.href,
            Referrer: document.referrer || ''
          };

          try {
            const browserBody = new URLSearchParams();
            const email = input.value.trim();
            browserBody.append('g', listId);
            browserBody.append('email', email);
            browserBody.append('$email', email);
            browserBody.append('$source', source);
            browserBody.append('$fields', Object.keys(properties).join(','));
            Object.entries(properties).forEach(([key, value]) => browserBody.append(key, value || ''));

            const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              body: browserBody.toString()
            });
            const result = await response.json();
            if (!response.ok || result.success !== true) throw new Error('Subscription failed');

            if (typeof window.fbq === 'function') {
              window.fbq('track', 'Lead', {
                content_name: 'Purple World Drop 2026 Signup',
                content_category: 'leadgen',
                drop: 'purple_world_drop_2026',
                language,
                country,
                market,
                source,
                list_id: listId,
                form_placement: placement
              });
            }

            form.hidden = true;
            status.hidden = true;
            success.hidden = false;
          } catch (error) {
            status.textContent = root.dataset.errorMessage;
            status.classList.add('purple-world-drop__status--error');
            button.textContent = originalLabel;
            button.disabled = false;
          } finally {
            form.removeAttribute('aria-busy');
            input.readOnly = false;
          }
        });
        });
      });
    };

    initializeSections();
    document.addEventListener('shopify:section:load', initializeSections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-drop-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSections = () => {
      document.querySelectorAll('[data-summer-drop-section]:not([data-summer-drop-ready])').forEach((root) => {
        root.dataset.summerDropReady = 'true';
        document.documentElement.classList.add('rm-summer-drop-page');

        const form = root.querySelector('[data-summer-drop-form]');
        const status = root.querySelector('[data-summer-drop-status]');
        const success = root.querySelector('[data-summer-drop-success]');
        const button = form?.querySelector('button');
        const input = form?.querySelector('input[type="email"]');

        const setHeaderHeight = () => {
          const pageOffset = Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY));
          root.style.setProperty('--summer-drop-header-height', `${pageOffset}px`);
        };

        setHeaderHeight();
        window.addEventListener('resize', setHeaderHeight, { passive: true });

        if (!form || !button || !input || !status || !success) return;

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!form.reportValidity()) return;

          const originalLabel = button.textContent;
          button.textContent = '...';
          button.disabled = true;
          status.classList.remove('summer-drop__status--error');

          const shopify = window.Shopify || {};
          const params = new URLSearchParams(window.location.search || '');
          const language = root.dataset.language || 'fr';
          const source = root.dataset.source || 'summer-drop-2026-signup';
          const listId = root.dataset.listId;
          const market = shopify.routes?.root || '/';
          const country = shopify.country || '';
          const placement = 'hero';
          const properties = {
            Source: `Summer Drop 2026 Landing Page - ${language.toUpperCase()}`,
            Drop: 'Summer Drop 2026',
            RM_Channel: params.get('utm_medium') || 'organic',
            RM_Source: source,
            RM_Drop: 'summer_drop_2026',
            RM_Campaign: 'Summer Drop 2026',
            Language: language,
            RM_Language: language,
            RM_Country: country,
            RM_Market_Root: market,
            Signup_Type: 'drop_notification',
            Form_Placement: placement,
            UTM_Source: params.get('utm_source') || 'instagram',
            UTM_Medium: params.get('utm_medium') || 'organic',
            UTM_Campaign: params.get('utm_campaign') || 'summer_drop_2026',
            UTM_Content: params.get('utm_content') || '',
            UTM_Term: params.get('utm_term') || '',
            Landing_Page: window.location.href,
            Referrer: document.referrer || ''
          };

          try {
            const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Xp3WuC', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2024-10-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: source,
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: input.value.trim(),
                          properties
                        }
                      }
                    }
                  },
                  relationships: {
                    list: {
                      data: {
                        type: 'list',
                        id: listId
                      }
                    }
                  }
                }
              })
            });

            if (!response.ok && response.status !== 202) throw new Error('Subscription failed');

            if (typeof window.fbq === 'function') {
              window.fbq('track', 'Lead', {
                content_name: 'Summer Drop 2026 Signup',
                content_category: 'leadgen',
                drop: 'summer_drop_2026',
                language,
                country,
                market,
                source,
                list_id: listId,
                form_placement: placement
              });
            }

            form.hidden = true;
            status.hidden = true;
            success.hidden = false;
          } catch (error) {
            status.textContent = root.dataset.errorMessage;
            status.classList.add('summer-drop__status--error');
            button.textContent = originalLabel;
            button.disabled = false;
          }
        });
      });
    };

    initializeSections();
    document.addEventListener('shopify:section:load', initializeSections);
  })();

  } catch(e) { console.error(e); }
})();
})();
